import styles from "./Slogan.module.css";

export default function Slogan({ title, text }) {
  return (
    <section className={"container " + styles.box}>
      <h2>{title}</h2>
      <h3>{text}</h3>
    </section>
  );
}
